var map = {
	"./alpha.jpg": "285c",
	"./amerique.jpg": "5097",
	"./arcenciel.jpg": "b8a1",
	"./demo.jpg": "60e5",
	"./elysee.jpg": "da2d",
	"./evasion.jpg": "da27",
	"./fascination.jpg": "11fa",
	"./forfaiterie.jpg": "9734",
	"./groupetco.jpg": "f5a0",
	"./isana-logo-1065x448.jpg": "6bfb",
	"./isana-logo.jpg": "ca2d",
	"./isana.jpg": "3c47",
	"./paradis.jpg": "e191",
	"./premont.jpg": "216e",
	"./solerama.jpg": "0187"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2898";